module.exports = global["$"] = require("-!./jquery.custom.js");